import type { FeatureCollection, LineString, Point } from "geojson";

// Coordinates and bounding boxes always use longitude, latitude (GeoJSON order).
export type Bounds = [number, number, number, number];
export const KYIV_BOUNDS: Bounds = [30.15, 50.15, 30.95, 50.75];
export const KYIV_CENTER: [number, number] = [30.5234, 50.4501];
export const ROAD_MIN_ZOOM = 14;
export const LANDMARK_KINDS = ["traffic_light", "road_sign", "crossing", "speed_bump"] as const;
export type LandmarkKind = typeof LANDMARK_KINDS[number];
export type TravelDirection = "forward" | "backward" | "both";

export const KIND_LABELS: Record<LandmarkKind, string> = {
    traffic_light: "Світлофор",
    road_sign: "Дорожній знак",
    crossing: "Пішохідний перехід",
    speed_bump: "Засіб заспокоєння руху",
};

export interface BindingInput {
    edgeId: string;
    direction: TravelDirection;
}

export interface Binding extends BindingInput {
    roadName: string;
    offsetMeters: number;
    distanceMeters: number;
    active: boolean;
}

export interface LandmarkInput {
    kind: LandmarkKind;
    title: string;
    signCode: string;
    signValue: string;
    longitude: number;
    latitude: number;
    viewHeading: number | null;
    accuracyMeters: number | null;
    verified: boolean;
    notes: string;
    bindings: BindingInput[];
    version?: number;
}

export interface Landmark extends Omit<LandmarkInput, "bindings" | "version"> {
    id: string;
    bindings: Binding[];
    source: "manual" | "osm";
    sourceRef: string | null;
    verifiedAt: string | null;
    updatedAt: string;
    version: number;
}

export interface RoadProperties {
    id: string;
    name: string;
    highway: string;
    oneWay: -1 | 0 | 1;
    lengthMeters: number;
    landmarkCount: number;
    verifiedCount: number;
}

export interface NearbyRoad extends RoadProperties {
    distanceMeters: number;
    bearing: number;
    geometry: LineString;
}

export interface MapData {
    roads: FeatureCollection<LineString, RoadProperties>;
    landmarks: FeatureCollection<Point, Landmark>;
    roadsTruncated: boolean;
    landmarksTruncated: boolean;
}

export interface NavigationStatus {
    ready: boolean;
    canEdit: boolean;
    roads: number;
    landmarks: number;
    verified: number;
    lastImport: { name: string; completedAt: string; bounds: Bounds } | null;
}

export interface StreetResult {
    name: string;
    bounds: Bounds;
}
